import Axios, { AxiosError, AxiosResponse } from "axios";
import { ReportListingReq } from "../types/Report";

const testBaseUrl = process.env.REACT_APP_BASE_URL || "";

export const reportProperty = (req: ReportListingReq) => {
  const willReportListing = new Promise<any>((resolve) => {
    Axios.post(testBaseUrl + "/api/Reports/ReportProperty", req)
      .then((response: AxiosResponse<any>) => {
        resolve({ data: response.data });
      })
      .catch((err: AxiosError | any) => {
        resolve({ error: err });
      });
  }); 
  return willReportListing;
};


